// https://talkjs.com/docs/Reference/JavaScript_Chat_SDK/Session/#Message__type

export const CHAT_MESSAGE_TYPE = {
  TEXT: 'text',
  MEDIA: 'media',
}
